// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"c097e7f2","200":"c736419c","729":"a1c40c77","872":"ec6eadea","900":"a6a92a0f","925":"3542b2b5"}[chunkId] + ".chunk.js";
};